import sitecoreIds from 'src/app_config/sitecore-ids.json';

import { SearchResult } from 'src/services/search/SearchDtos';

import { ExtendedItem } from 'src/types/ExtendedItem';
import { ResourceListItem } from 'src/types/ResourceListItem';

import { mapClinicalTopic } from './clinicalTopicMapper';
import { mapContentCard } from './contentCardMapper';
import { mapCPDArticle } from './cpdArticleMapper';
import { mapLearningModule } from './learningModuleMapper';
import { mapLMSCourse } from './lmsCourseMapper';
import { mapResourcePage } from './resourcePageMapper';
import { mapSearchResult } from './searchResultMapper';

export function mapResourceListItem(item: ExtendedItem | SearchResult, wildcardUrl?: string): ResourceListItem | null {
	if (!item) {
		console.error('Null Argument Error - Item is null, unable to create a list item.');
		return null;
	}

	let resourceListItem: ResourceListItem | null = null;

	if ('fields' in item) {
		switch (item.templateId.toLowerCase()) {
			case sitecoreIds.Templates.ClinicalTopicLandingPageTemplateId.toLowerCase():
				resourceListItem = mapClinicalTopic(item, wildcardUrl);
				break;
			case sitecoreIds.Templates.ClinicalTopicContentPageTemplateId.toLowerCase():
				resourceListItem = mapClinicalTopic(item, wildcardUrl);
				break;
			case sitecoreIds.Templates.LMSCourseTemplateId.toLowerCase():
				resourceListItem = mapLMSCourse(item);
				break;
			case sitecoreIds.Templates.RCNiCPDArticleTemplateId.toLowerCase():
				resourceListItem = mapCPDArticle(item, wildcardUrl);
				break;
			case sitecoreIds.Templates.RCNiLearningModuleTemplateId.toLowerCase():
				resourceListItem = mapLearningModule(item, wildcardUrl);
				break;
			case sitecoreIds.Templates.ContentCardTemplateId.toLowerCase():
				resourceListItem = mapContentCard(item);
				break;
			case sitecoreIds.Templates.ResourcePageTemplateId.toLowerCase():
				resourceListItem = mapResourcePage(item, wildcardUrl);
				break;
			default:
				console.error(`Unable to map Content with TemplateId ${item.templateId}.`);
				resourceListItem = null;
				break;
		}
	}

	if ('Title' in item) {
		resourceListItem = mapSearchResult(item, wildcardUrl);
	}

	return resourceListItem;
}
